import RenameContentDialog from './RenameContentDialog';
export default RenameContentDialog;
